// extracted by mini-css-extract-plugin
export var container = "_b2-1";
export var cornerButtonContainer = "_b2-5";
export var disabled = "_b2-2";
export var fileContainer = "_b2-4";
export var hiddenInput = "_b2-3";
export var widthContainer = "_b2-0";